/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_BrowseInputs */



/**
* | output |
* | --- |
* | "Browse events" |
*
* @param {Landing_BrowseInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_browse = /** @type {((inputs?: Landing_BrowseInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_BrowseInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vedi i tornei")
	return /** @type {LocalizedString} */ ("Browse events")
});